import { removeAccents } from "../utils/stringNormalization";
export const COUNTRIES = [
  {
    code: "EC",
    isoA3: "ECU",
    name: "Ecuador",
    bcCountryCode: "EC",
    // Zona horaria esperada de las cajas del país. No es la que usa el terminal
    // --ése usa siempre el reloj del equipo--: es contra la que se compara para
    // avisar si el equipo está mal configurado (utils/husoDelEquipo.js). Ecuador
    // tiene además Galápagos (UTC−6), que hoy daría aviso.
    timeZone: "America/Guayaquil",
    currency: "USD",
    currencyName: "Dólares",
    currencySymbol: "$",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix", //prefix ó suffix como opciones válidas
    decimals: 2,
  },
  {
    code: "PY",
    isoA3: "PRY",
    name: "Paraguay",
    bcCountryCode: "PY",
    timeZone: "America/Asuncion",
    currency: "PYG",
    currencyName: "Guaraníes",
    currencySymbol: "₲",
    thousandSeparator: ".",
    decimalSeparator: ",",
    currencyPosition: "prefix",
    decimals: 0,
  },
  {
    code: "HN",
    isoA3: "HND",
    name: "Honduras",
    bcCountryCode: "HN",
    timeZone: "America/Tegucigalpa",
    currency: "HNL",
    currencyName: "Lempiras",
    currencySymbol: "L",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2,
  },
  {
    code: "PE",
    isoA3: "PER",
    name: "Perú",
    bcCountryCode: "PE",
    timeZone: "America/Lima",
    currency: "PEN",
    currencyName: "Soles",
    currencySymbol: "S/",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2,
  },
  {
    code: "BO",
    isoA3: "BOL",
    name: "Bolivia",
    bcCountryCode: "BO",
    timeZone: "America/La_Paz",
    currency: "BOB",
    currencyName: "Bolivianos",
    currencySymbol: "Bs",
    thousandSeparator: ".",
    decimalSeparator: ",",
    currencyPosition: "prefix",
    decimals: 2,
  },
  {
    code: "GT",
    isoA3: "GTM",
    name: "Guatemala",
    bcCountryCode: "GT",
    timeZone: "America/Guatemala",
    currency: "GTQ",
    currencyName: "Quetzales",
    currencySymbol: "Q",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2,
  },
  {
    code: "SV",
    isoA3: "SLV",
    name: "El Salvador",
    bcCountryCode: "SV",
    timeZone: "America/El_Salvador",
    currency: "USD",
    currencyName: "Dólares",
    currencySymbol: "$",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2,
  },
  {
    code: "CR",
    isoA3: "CRI",
    name: "Costa Rica",
    bcCountryCode: "CR",
    timeZone: "America/Costa_Rica",
    currency: "CRC",
    currencySymbol: "₡",
    thousandSeparator: ".",
    decimalSeparator: ",",
    currencyPosition: "prefix",
    // Cinco, y es deliberado: Costa Rica escribe sus importes con cinco
    // decimales en pantalla.
    //
    // Estuvo un rato en 2 por una corrección equivocada mía. El cajero veía
    // «₡ 515.628,40740» en el cierre y el campo no le dejaba teclearlo de
    // vuelta, y bajé los decimales. El problema no eran los cinco decimales:
    // era que el campo **mostraba con la convención del país y leía con la
    // inglesa**. Eso se arregló en `utils/campoDeMoneda.js`, y los cinco
    // decimales vuelven a su sitio.
    //
    // Este campo es **de formato**, no de cálculo: la precisión de cálculo la
    // da `resolveMoneyDecimals` en utils/money.js, y da 5 también. Que hoy
    // coincidan no las hace la misma cosa.
    decimals: 5,
  },
  {
    code: "PA",
    isoA3: "PAN",
    name: "Panamá",
    bcCountryCode: "PA",
    timeZone: "America/Panama",
    // El balboa es la unidad de cuenta, pero se factura y se cobra en dólares:
    // circulan a la par y el papel es el estadounidense. Así que la moneda es
    // USD y el arqueo cuenta las mismas denominaciones que Ecuador.
    currency: "USD",
    currencySymbol: "$",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    // Dos, y no los cinco de Costa Rica: aquéllos son una exigencia del XML de
    // Hacienda costarricense, no algo que se herede por compartir ambiente. La
    // precisión de CÁLCULO la da `resolveMoneyDecimals`, que sigue dando 5 sólo
    // para "CR".
    decimals: 2,
  },
  {
    code: "PR",
    isoA3: "PRI",
    name: "Puerto Rico",
    bcCountryCode: "PR",
    timeZone: "America/Puerto_Rico",
    // Dólar estadounidense de verdad, no a la par como en Panamá: Puerto Rico es
    // territorio de Estados Unidos y el dólar es su moneda. Formato anglosajón,
    // igual que Ecuador y Panamá.
    currency: "USD",
    // Panamá no declara `currencyName` y se nota en tres sitios --el registro de
    // divisa, la pantalla de Configuración y el tiquete--, donde acaba
    // imprimiendo «USD» en vez del nombre. Aquí se declara desde el principio.
    currencyName: "Dólares",
    currencySymbol: "$",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    // Dos de formato. La precisión de CÁLCULO la sigue dando `resolveMoneyDecimals`,
    // que reserva los cinco decimales para Costa Rica.
    decimals: 2,
  },
];

// Mapa para usar claves fácilmente en configs o condicionales
export const COUNTRY_CODES = COUNTRIES.reduce((acc, country) => {
  acc[removeAccents(country.name).replace(/\s+/g, "").toUpperCase()] = country.code;
  return acc;
}, {});

/**
 * Mapa de países indexado por código
 *
 * Uso:
 *   const country = countryMap["HN"];
 */
export const countryMap = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
